import axios from '@axios'
import { get } from '@vueuse/core'

const route = 'stock'

export default {
  namespaced: true,
  state: {
    stocks: [],
    product: {},
    extractProductId: null,
  },
  getters: {
    getStocks(state) {
      return state.stocks
    },
    getExtractProductId(state) {
      return state.extractProductId
    },
    getProduct(state) {
      return state.product
    },
  },
  mutations: {
    setStocks(state, stocks) {
      state.stocks = stocks
    },
    setExtractProductId(state, product_id) {
      state.extractProductId = product_id
    },
    setProduct(state, product) {
      state.product = product
    },
  },
  actions: {
    getAll(context, { itemsPerPage, page, data }) {
      return axios.post(`${route}/get_stock` + `?page=${page}&items_per_page=${itemsPerPage}`, data)
    },

    updateOrStore(context, purchaseStock) {
      return axios.post(`${route}/update_or_store`, purchaseStock)
    },

    store(context, purchaseStock) {
      return axios.post(route, purchaseStock)
    },

    update(context, card) {
      return axios.put(`${route}/${card.id}`, card)
    },

    destroy(context, purchaseStockId) {
      return axios.delete(`${route}/${purchaseStockId}`)
    },

    getExtract(context, { product_id, dateExtract }) {
      return axios.get(`${route}/get_extract/${product_id}/${dateExtract}`)
    },

    getMovementTypes() {
      return axios.get(`${route}/get_movement_types`)
    },

    storeAdjustment(context, adjustment) {
      return axios.post(`${route}/adjustment`, adjustment)
    },

    exportExcel(context) {
      const route = 'stock/export_excel'

      return axios.get(route, {
        responseType: 'blob',
      })
    },

    exportPdf(context, payload) {
      const route = 'stock/export_pdf'

      return axios.post(route, payload, {
        responseType: 'blob',
      })
    },
  },
}
